// extracted by mini-css-extract-plugin
export default {"blockTitle":"RichText_blockTitle__2SKAe","content":"RichText_content__e4Lpv"};